import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FS } from "src/configs/constance";
import vaultsConfig from "src/configs/treasure-map-vaults";
import NFTTreasureMapContract from "src/contract-logic/logic/NFTTreasureMapContract";
import multiCall from "src/utils/multicall";
import CollectionQuery from "src/utils/query/onchain/multi-call-query/collection-query";

export const fetchCollectionsTreasureMap = createAsyncThunk(
  "expeditionSlice/fetchCollectionsTreasureMap",
  async ({ vaultId }, thunkAPI) => {
    const vault = vaultsConfig[vaultId];
    const accountAddress = thunkAPI.getState().accountSlice.address;
    const contract = NFTTreasureMapContract.getContractTreasureMap(vault.contractAddress, {
      decimals: 18,
    });
    const collectionLength = await contract.getTokenOfOwnerBalance(accountAddress);
    const [collectionIds] = await Promise.all([
      multiCall(
        NFTTreasureMapContract.ABI,
        new Array(collectionLength).fill(1).map((_, idx) => ({
          address: vault.contractAddress,
          name: "getTokenOfOwnerAtIndex",
          params: [accountAddress, idx],
        }))
      ),
    ]);
    const collectionIdsFlattened = collectionIds.flat();
    const { normalCollections, specialCollections } = await CollectionQuery.fetchBasicCollections(
      collectionIdsFlattened
    );

    let armorTokenIdArray = [];
    let helmetTokenIdArray = [];
    let shieldTokenIdArray = [];
    let weaponTokenIdArray = [];
    normalCollections.forEach((item, _) => {
      armorTokenIdArray.push(item.armorTokenId);
      helmetTokenIdArray.push(item.helmetTokenId);
      shieldTokenIdArray.push(item.shieldTokenId);
      weaponTokenIdArray.push(item.weaponTokenId);
    });

    const normalItemsCollections = await CollectionQuery.fetchNormalItems(
      armorTokenIdArray,
      helmetTokenIdArray,
      shieldTokenIdArray,
      weaponTokenIdArray
    );

    const v1 = [];
    const v2 = [];
    let counter = 0;
    for (const rawCollection of normalCollections) {
      if (rawCollection.setId == 1) v1.push({ ...rawCollection, ...normalItemsCollections[counter] });
      else if (rawCollection.setId == 2) v2.push({ ...rawCollection, ...normalItemsCollections[counter] });
      counter++;
    }

    return specialCollections.concat(v1);
  }
);

export const fetchAllVaultTreasureData = createAsyncThunk(
  "treasureMapSlice/fetchAllVaultTreasureData",
  async (_, thunkAPI) => {
    await Promise.all(
      Object.entries(vaultsConfig).map(([vaultId, _]) => thunkAPI.dispatch(fetchVaultTreasureMapData({ vaultId })))
    );
  }
);

export const fetchVaultTreasureMapData = createAsyncThunk(
  "treasureMapSlice/fetchVaultTreasureMapData",
  async ({ vaultId }, thunkAPI) => {
    const accountAddress = thunkAPI.getState().accountSlice.address;
    const rarities = [1, 2, 3, 4, 5, 6];
    const vault = vaultsConfig[vaultId];
    const contract = NFTTreasureMapContract.getContractTreasureMap(vault.contractAddress, {
      decimals: 18,
    });
    const treasureMapCount = await Promise.all(rarities.map(async (item) => await contract.getTreasureMapCount(item)));
    const deployedCollections = await thunkAPI.dispatch(fetchCollectionsTreasureMap({ vaultId }));
    const [time, price] = await Promise.all([contract.getTreasureMapDuration(), contract.getTreasureMapPrice()]);
    if (accountAddress) {
      return { ...vault, time, price, treasureMapCount, deployedCollections: deployedCollections.payload };
    } else {
      return { ...vault, time, price, treasureMapCount };
    }
  }
);

const initialState = {
  vaults: {},
  fetchingStatus: FS.INITIAL,
};

const treasureMapSlice = createSlice({
  name: "treasureMapSlice",
  initialState: initialState,
  reducer: {},
  extraReducers: (builder) =>
    builder
      .addCase(fetchAllVaultTreasureData.pending, (state, _) => {
        state.fetchingStatus = FS.FETCHING;
      })
      .addCase(fetchAllVaultTreasureData.rejected, (state, action) => {
        state.fetchingStatus = FS.FAIL;
        console.error(action);
      })
      .addCase(fetchAllVaultTreasureData.fulfilled, (state, _) => {
        state.fetchingStatus = FS.SUCCESS;
      })
      .addCase(fetchVaultTreasureMapData.fulfilled, (state, action) => {
        const vaultId = action.meta.arg.vaultId;
        state.vaults[vaultId] = { ...state.vaults[vaultId], ...action.payload };
      }),
});

export default treasureMapSlice.reducer;
